<script lang="ts">
  import { useActions, type HTMLActionArray } from "#lib/internal/helpers"
  import type { Snippet } from "svelte"
  import { cn, headerCellVariants } from ".."
  import { getTableRootContext } from "./Table.svelte"

  const rootCtx = getTableRootContext()

  type Props = {
    span?: number
    use?: HTMLActionArray
    class?: string
    children?: Snippet
    [key: string]: unknown
  }

  let {
    span = undefined,
    use = [],
    class: cssClass = "",
    children,
    ...restProps
  }: Props = $props()
</script>

<span
  class={cn(headerCellVariants({ variant: $rootCtx.variant }), cssClass)}
  role="columnheader"
  data-fixed-span={span ?? "undefined"}
  use:useActions={use}
  {...restProps}
>
  {@render children?.()}
</span>
